// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"b4947604","3050":"b4947604","4066":"b4947604"}[chunkId] + ".chunk.css";
};